/* global ko, $ */

function SignInViewModel(options) {
    this.username = ko.observable('');
    this.baseUrl = Cartegraph.Utilities.getBaseURL();
    this.password = ko.observable('');
    this.error = ko.observable(options.error);
    this.loading = ko.observable(false);
    this.isInternalRequest = options.isInternalRequest;
    this.buttonText = ko.computed(function() {
        var loading = this.loading();
        return loading ? "Signing In" : "Sign In";
    }, this);

    this.signInButtonEnabled = ko.computed(function () {
        var loading = this.loading();
        var formFilled = (this.username().length > 0 && this.password().length > 0);

        return !loading && formFilled;
    }, this);

    this.submit = function (signInAnon) {
        var self = this;
        if (!signInAnon && !self.signInButtonEnabled()) {
            return;
        }
        this.loading(true);

        if (signInAnon)
        {
            self.username("");
            self.password("");
        }

        $.post(Cartegraph.AjaxURL.API("authenticate"), { userName: self.username(), password: self.password(), isInternalRequest: self.isInternalRequest, honorEsriLicensing: true })
            .then(function (data) {
                // Preserve the hash after the login to attempt to navigate to the intended location
                // This will not do anything for internal requests since the hash is replaced by #InternalRequest, but it also doesn't hurt
                if (data.LogOnStatus === 0) {
                    if (self.isInternalRequest) {
                        Cartegraph.PendoService.trackLoginType("Internal Request");
                        window.location = self.baseUrl + "InternalRequest";
                    } else {
                        let returnUrl = new URLSearchParams(window.location.search).get("ReturnUrl");
                        if (returnUrl)
                            // If there is a return url, it will be a relative url (including the virtual directory)
                            // So you have to tack the rest of the origin back on
                            returnUrl = window.location.origin + returnUrl;
                        else
                            // Otherwise, navigate to the base url
                            returnUrl = self.baseUrl;

                        // Either way, preserve the hash
                        if (window.location.hash)
                            returnUrl += window.location.hash;

                        Cartegraph.PendoService.trackLoginType("Cartegraph");
                        window.location = returnUrl;
                    }
                }
            }, function (data) {
                self.loading(false);
                self.error(data.responseJSON.Message);
            });
    };

    this.forgotPassword = function () {
        var self = this;
        window.location = Cartegraph.AjaxURL.Account('ForgotPassword', { userName: self.username(), isInternalRequest: self.isInternalRequest });
    }

    this.logInWithEsri = function () {
        var self = this;
        const params = {
            userName: self.username(),
            isInternalRequest: self.isInternalRequest
        };

        const returnUrl = new URLSearchParams(window.location.search).get("ReturnUrl");
        if (returnUrl)
            // The oAuth controller handles this as a relative URL, so no need to do anything more with it
            params.returnUrl = returnUrl;
        else
            // Even if there isn't a return url, there might still be a hash, so set it to something
            params.returnUrl = "";

        // Either way, preserve the hash
        if (window.location.hash)
            params.returnUrl += window.location.hash;

        Cartegraph.PendoService.trackLoginType("Esri");
        window.location = Cartegraph.AjaxURL.OAuth('LoginWithEsri', this.uriEncodeValues(params));
    }

    /**
     * Manually encode every value of an object
     * Since we pulle the return url from the url, we need to re-encode it.
     * It could have have parameters already url encoded,
     * and our internal Ajax url function won't double encode
     */
    this.uriEncodeValues = function (params) {
        var self = this;
        const encodedParams = {};
        for (const key in params) {
            encodedParams[key] = encodeURIComponent(params[key]);
        }

        return encodedParams;
    }
};